import { RouteMember } from '@/javascript/domain/entities/maps/route-member'
import { RoutePoint } from '@/javascript/domain/entities/maps/route-point'
import { ListMapper } from './mapper'
import { RemoteRouteMember } from '@/javascript/data/entities'

export class RouteMemberMapper extends ListMapper<RouteMember, RemoteRouteMember> {
  constructor(
    private readonly routePointMapper: ListMapper<RoutePoint>
  ) { super() }

  toEntity (data: RemoteRouteMember): RouteMember {
    return {
      id: data.id,
      accountMemberId: data.account_member?.id,
      accountMemberCompleteData: data.account_member?.user?.complete_name_and_email,
      routingRouteId: data.routing_route_id,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
      origin: {
        address: data.origin_address,
        lat: parseFloat(data.origin_lat),
        lng: parseFloat(data.origin_lng)
      },
      destination: {
        address: data.destination_address,
        lat: parseFloat(data.destination_lat),
        lng: parseFloat(data.destination_lng)
      },
      totalTimeSeconds: data.total_time_seconds,
      serviceTimeSeconds: data.service_time_seconds,
      travelTimeSeconds: data.travel_time_seconds,
      totalDistanceMeters: data.total_distance_meters,
      geometry: JSON.parse(data.geometry),
      pointsCount: data.points_count,
      points: this.routePointMapper.toEntityList(data.points)
    }
  }
}
